import styled from 'styled-components';

export const AnimatedIconContainer = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  pointer-events: none;
  vertical-align: middle;
  transform: scale(1.5);
`;
